export const ADD_BATCH = "ADD_BATCH"
export const EDIT_BATCH = "EDIT_BATCH"
export const LIST_BATCH = "LIST_BATCH"
export const LIST_TRACK_BATCH = "LIST_TRACK_BATCH"
export const VIEW_BATCH = "VIEW_BATCH"
export const DELETE_BATCH = "DELETE_BATCH"

// Text
export const ADD_PARTICIPANTS = "ADD_PARTICIPANTS"
export const EDIT_PARTICIPANTS = "EDIT_PARTICIPANTS"
export const LIST_PARTICIPANTS = "LIST_PARTICIPANTS"
export const LIST_PARTICIPANTSTATUS = "LIST_PARTICIPANTSTATUS"
export const LIST_PARTICIPANTS_TRACK_BATCH = "LIST_PARTICIPANTS_TRACK_BATCH"
export const VIEW_PARTICIPANTS = "VIEW_PARTICIPANTS"
export const DELETE_PARTICIPANTS = "DELETE_PARTICIPANTS"
export const SEND_INVITATION_MAIL = "SEND_INVITATION_MAIL"


export const BATCH_SUCCESS = "BATCH_SUCCESS"
export const BATCH_ERROR = "BATCH_ERROR"

